// test2977
(2977 && 0);
